import { MenuItem, Select, Stack, ToggleButton, Typography } from '@mui/material';
import { StyledToggleButtonGroup } from './controlViewSwitch.styles';
import * as React from 'react';
import { NO_COMPARISON, useYearContext } from '../../context';
import { lloydConstants } from '../../Constants';

const YearToggle = () => {
	const { selectedYear, setSelectedYear, comparisonYear, setComparisonYear } = useYearContext();

	const handleYearChange = (event, value) => {
		if (!value) return;

		setSelectedYear(value);

		// Comparing a wave with itself says nothing, so step to the wave before it.
		if (value === comparisonYear) {
			const earlier = lloydConstants.waves.find((year) => year < value);
			setComparisonYear(earlier ?? NO_COMPARISON);
		}
	};

	const handleComparisonChange = (event) => {
		const { value } = event.target;
		setComparisonYear(value === NO_COMPARISON ? NO_COMPARISON : Number(value));
	};

	return (
		<Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} gap={'8px 12px'}>
			<StyledToggleButtonGroup color="primary" value={selectedYear} exclusive onChange={handleYearChange}>
				{lloydConstants.waves.map((year) => (
					<ToggleButton key={year} value={year}>
						{year}
					</ToggleButton>
				))}
			</StyledToggleButtonGroup>

			<Stack direction={'row'} spacing={'8px'} alignItems={'center'}>
				<Typography variant={'body2'} color={'text.secondary'} whiteSpace={'nowrap'}>
					Compare with
				</Typography>
				<Select size={'small'} value={comparisonYear} onChange={handleComparisonChange} sx={{ minWidth: 100 }}>
					{lloydConstants.waves
						.filter((year) => year !== selectedYear)
						.map((year) => (
							<MenuItem key={year} value={year}>
								{year}
							</MenuItem>
						))}
					<MenuItem value={NO_COMPARISON}>None</MenuItem>
				</Select>
			</Stack>
		</Stack>
	);
};

export default YearToggle;
